export default "__VITE_ASSET__rpr52FeG__"